__turbopack_context__.v({
  "button": "button-component-module-scss-module__J1ukVG__button",
  "button--as-text": "button-component-module-scss-module__J1ukVG__button--as-text",
  "button--disabled": "button-component-module-scss-module__J1ukVG__button--disabled",
  "button--icon-only": "button-component-module-scss-module__J1ukVG__button--icon-only",
  "button--looks-disabled": "button-component-module-scss-module__J1ukVG__button--looks-disabled",
  "button--no-style": "button-component-module-scss-module__J1ukVG__button--no-style",
  "button--outline": "button-component-module-scss-module__J1ukVG__button--outline",
  "button--primary": "button-component-module-scss-module__J1ukVG__button--primary",
  "button--secondary": "button-component-module-scss-module__J1ukVG__button--secondary",
  "button--tertiary": "button-component-module-scss-module__J1ukVG__button--tertiary",
  "button--underline": "button-component-module-scss-module__J1ukVG__button--underline",
  "button--uppercase": "button-component-module-scss-module__J1ukVG__button--uppercase",
  "button-icon--large": "button-component-module-scss-module__J1ukVG__button-icon--large",
  "button-icon--medium": "button-component-module-scss-module__J1ukVG__button-icon--medium",
  "button-icon--small": "button-component-module-scss-module__J1ukVG__button-icon--small",
  "button-icon--spinning": "button-component-module-scss-module__J1ukVG__button-icon--spinning",
  "button__content": "button-component-module-scss-module__J1ukVG__button__content",
  "button__content--has-icons": "button-component-module-scss-module__J1ukVG__button__content--has-icons",
  "spin-rotation": "button-component-module-scss-module__J1ukVG__spin-rotation",
});
